export default __webpack_public_path__ + "static/media/spinnerLogo.a6b07ad7.svg";